import type { ReactNode } from "react";
import { ChevronRight, HandCoins } from "lucide-react";
import type { Account, IOU } from "../../../types";
import type { View } from "../../../app/views";
import { money } from "../../../lib/finance";
import { owed } from "../overview-data";
import { Private } from "../../../components/Privacy";

export default function MoneyOwed({ ious, selectedAccounts, collapsed, collapseButton, nav }: {
  ious: IOU[];
  selectedAccounts: Account[];
  collapsed: boolean;
  /** The module's collapse toggle, drawn by the caller so every module's matches. */
  collapseButton: ReactNode;
  nav: (view: View) => void;
}) {
  const { open: openIous, lines: iouLines } = owed(ious, selectedAccounts);
  if (!iouLines.length) return null;
  return (
    <section className={`position-card overview-module${collapsed ? " is-collapsed" : ""}`}>
      <div className="section-heading">
        <h2>Money owed</h2>
        <div className="overview-heading-actions"><strong className="collapsed-summary">{openIous.length} open</strong><HandCoins size={19} />{collapseButton}</div>
      </div>
      {iouLines.map((line) => (
        <div className="position-line" key={line.key}>
          <span>
            <i className={`dot ${line.dot}`} />
            {line.label}
          </span>
          <strong><Private>{money(line.amount, line.currency)}</Private></strong>
        </div>
      ))}
      <button className="net-position owed-link" onClick={() => nav("ious")}>
        <span>
          {openIous.length} open {openIous.length === 1 ? "IOU" : "IOUs"}
          <small>Sits outside the net position above</small>
        </span>
        <ChevronRight size={18} />
      </button>
    </section>
  );
}
